import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';

const LazyClientAssociateDrawer = React.lazy(
	() => import('../components/ClientAssociateContactsDrawer')
);
export const AssociateContactToClientDrawer: React.FC<
	OverlayDrawerComponentProps<'urn:sfdrawer:client-mgt-pilet:client-associate-contacts:intake'>
> = props => {
	return (
		<React.Suspense
			fallback={<div data-testid="loading-client-associate-contacts-drawer" />}
		>
			<LazyClientAssociateDrawer initialParameters={props} />
		</React.Suspense>
	);
};
